import { FC, useState } from 'react'
import PerButtonCircle from '../ButtonCircle'
import { PerSpacerProps } from '../Spacer'
import { Popover } from 'antd'
import PerText from '../Text'
import { useObjectiveAttachmentHelper, atobUtf8 } from '../../../shared/useObjectiveAttachmentHelper'
import { getObjectiveAttachmentHref } from '../../../modules/meeting/util/hrefUtils'
import { useObjectivesWithAttachmentsFromMeeting } from '../../../graphql/objectives/useObjectivesWithAttachmentsFromMeeting'
import { useTranslation } from 'react-i18next'
import { ObjectiveAttachmentInfoDto } from '../../../types'

const AttachmentLine: FC<{ objective: ObjectiveAttachmentInfoDto; employeeId: string; onClick: () => void }> = ({
  objective,
  employeeId,
  onClick,
}) => {
  const { extractHumanReadableFileName } = useObjectiveAttachmentHelper(atobUtf8)

  return objective.attachment && objective.attachmentDownloadToken ? (
    <PerText fontSize="m" className="text-ellipsis attachment" color="primary">
      <a onClick={onClick} href={getObjectiveAttachmentHref(String(employeeId), objective.attachment, objective.attachmentDownloadToken)}>
        {extractHumanReadableFileName(objective.attachment)}
      </a>
    </PerText>
  ) : null
}

const renderAttachmentLines = (objectives: ObjectiveAttachmentInfoDto[], employeeId: string, onClick: () => void) =>
  objectives.map((obj, i) => <AttachmentLine key={obj.globalId || i} objective={obj} employeeId={employeeId} onClick={onClick} />)

interface PdfObjectiveAttachmentPopoverProps extends PerSpacerProps {
  meetingId: number
  employeeId: string
}

export const PdfObjectiveAttachmentPopover: FC<PdfObjectiveAttachmentPopoverProps> = ({ meetingId, employeeId, ...spacerProps }) => {
  const { t } = useTranslation()
  const [opened, setOpened] = useState(false)
  const { data, error } = useObjectivesWithAttachmentsFromMeeting(meetingId)

  const togglePopover = () => {
    setOpened(!opened)
  }

  if (!data || !data.objectivesWithAttachmentsFromMeeting.length || error) {
    return null
  }

  return (
    <Popover
      title={<PerText color="secondary">{t('appraisalMeeting.pdfDownloadPopover.attachments')}</PerText>}
      trigger="click"
      visible={opened}
      onVisibleChange={setOpened}
      content={renderAttachmentLines(data.objectivesWithAttachmentsFromMeeting, employeeId, togglePopover)}
      destroyTooltipOnHide
    >
      <PerButtonCircle
        icon="attachment_fill"
        color="primary"
        variant="pastel"
        tooltip={t('tooltip.view')}
        onClick={togglePopover}
        {...spacerProps}
      />
    </Popover>
  )
}
